import React from "react";
import { List } from "semantic-ui-react";
import PropTypes from "prop-types";

const ListaDocumentosContractuales = ({urlDocumentoContrato, urlDocumentoPlantilla}) => {
  return (
    <>
      <List>
        <List.Item>
          <List.Icon name="file text" color="blue" />
          <List.Content>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={urlDocumentoContrato}
            >
              Contrato de Servicios Bancarios
            </a>
          </List.Content>
        </List.Item>
        <List.Item>
          <List.Icon name="file text" color="blue" />
          <List.Content>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={urlDocumentoPlantilla}
            >
              Cartilla de Información
            </a>
          </List.Content>
        </List.Item>
      </List>
    </>
  );
};

ListaDocumentosContractuales.propTypes = {
  urlDocumentoContrato: PropTypes.string.isRequired,
  urlDocumentoPlantilla: PropTypes.string.isRequired,
};

export default ListaDocumentosContractuales;
